

export const AUTH_LOGIN_ENDPOINT = "/auth/login";
export const AUTH_SIGNUP_ENDPOINT = "/auth/signup";
export const AUTH_LOGOUT_ENDPOINT = "/auth/logout";
export const AUTH_REFRESH_TOKEN_ENDPOINT = "/auth/refresh-token";
export const AUTH_VERIFY_OTP_ENDPOINT = "/auth/verify";
export const AUTH_SEND_OTP_ENDPOINT = "/auth/getcode";
export const AUTH_PASSWORD_RESET_ENDPOINT = "/user/password/send_reset";
export const BUILDING_CONFIG_ENDPOINT = "/buildingconfig";
export const FEATURE_FLAG_ENDPOINT = "/featureflag";

// Building endpoints
export const BUILDING_CHECK_CODE_ENDPOINT = "/v2/building/check-code";

// User endpoints
export const USER_MATCH_ENDPOINT = "/v2/user/match";
export const USER_PUBLIC_PROFILE_ENDPOINT = "/publicprofile";
export const USER_REPORT_ENDPOINT = "/userreport";
export const USER_CHANGE_PASSWORD_ENDPOINT = "/user/update-password";
export const USER_DELETE_ACCOUNT_ENDPOINT = "/user/request-account-deletion";
export const USER_MY_PROFILE_ENDPOINT = "/user/my-profile";
export const USER_MY_RESTRICTION_ENDPOINT = "/user/my-restriction";
export const USER_UPDATE_ENDPOINT = "/user";
export const STREAM_BAN_USER_ENDPOINT = "/stream/ban-user";
export const ONEAPP_USER_RESOLVE_ENDPOINT = "/oneapp/user/resolve";
export const MAINTENANCE_MODE_ENDPOINT = "/public/maintenance-mode";
export const ONEAPP_INTERCOM_JWT_ENDPOINT = "/oneapp/intercom-jwt";
export const ONEAPP_ACCEPT_TERMS_ENDPOINT = "/oneapp/accept-terms";

// Groups endpoints
export const GROUPS_ENDPOINT = "/group";
export const GROUPS_OF_USER_ENDPOINT = "/user/groups";

// Building endpoints
export const BUILDING_TILES_ENDPOINT = "/building/building-tiles";
export const BUILDING_TOOLTIP_ENDPOINT = "/tooltip";
export const BUILDING_UNIVERSAL_BUTTON_ENDPOINT = "/building";

// Perk endpoints
export const PERK_ENDPOINT = "/perk";
export const SAVED_PERK_ENDPOINT = "/savedperk";
export const REFERRAL_OFFER_ENDPOINT = "/referral/referral-offer";
export const GET_REFERRAL_LINK_ENDPOINT = "/referral/get-referral-link";
export const REFERRAL_USER_SETTINGS_ENDPOINT = "/referral/user-setting";
export const GET_REFERRAL_STATS_ENDPOINT = "/referral/get-stats";

// Notification endpoints
export const NOTIFICATIONS_ENDPOINT = "/notification";
export const NOTIFICATIONS_MARK_ALL_READ_ENDPOINT = "/notification/mark-all";
export const NOTIFICATIONS_MARK_READ_ENDPOINT = "/notification";
export const NOTIFICATION_TYPES_ENDPOINT = "/notificationtype";

// Intercom endpoints
export const INTERCOM_ENDPOINT = "/intercom";

// Places endpoints
export const PLACE_ENDPOINT = "/place";
export const PLACE_COMMENT_ENDPOINT = (placeId: string) => `/place/${placeId}/comment`;

